import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { AdminNpcs, AdminNpcNew, AdminNpcEdit } from 'containers'

export const AdminNpcRouter = () => {
  return (
    <Routes>
      <Route path="/new"       element={<AdminNpcNew />} />
      <Route path="/:id/edit"  element={<AdminNpcEdit />} />
      <Route path="/"          element={<AdminNpcs />} />
    </Routes>
  )
}
